import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { getNumberComma } from '../../utils/numberUtils';

const GoalStaticTableCell = ({ data, headerRows }) => {
  if (!headerRows || !data) return null;

  return (
    headerRows.map((field, fIndex) => {
      const rawValue = _.get(data, field, '-');
      const isNumber = typeof rawValue === 'number' || (!isNaN(Number(rawValue)) && rawValue !== '');
      const formatValue = isNumber ? getNumberComma(rawValue) : '-';

      const amountCellStyle = {
        minWidth: '100px',
        maxWidth: '115px',
        
      
        fontSize: '0.85rem',
        fontWeight: 500,
        letterSpacing: '-0.4px', 
        padding: '6px 8px', 
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        border: '1px solid #e0e0e0',
        color: rawValue === 0 ? '#ccc' : '#333',
      };

      return (
        <TableCell
          key={fIndex}
          align="right"
          sx={amountCellStyle}
          title={formatValue}
        >
          {formatValue}
        </TableCell>
      );
    })
  );
};

export default GoalStaticTableCell;
